module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', [_vm._v("About the Author")]), _vm._v(" "), _c('p', [_vm._v("Puthalath Raghuprasad has many talents. His first talent is painting. His favorite medium is oil, and he creates realistic pictures on canvas, including portraits, scenery/landscapes, birds, animals, and flowers. His second talent is writing in prose, but lately, he has also written several poems. He is also proficient in inventing; he holds 21 US patents, and two of them are at different stages of manufacturing. Finally, he has formulated his own theory about the universe in which gravity and the ever-present axial rotation cooperate to give rise to the motions of all celestial bodies.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ad60488","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0